<template>
  <div :class="['drawer-container',qwMap?'qwMap':'']">
      <map-head-check-box class="m-c" :location="location"></map-head-check-box>
      <company-card-list v-loading.lock="loading" element-loading-text="耐心等待小T为您大数据计算中…" element-loading-spinner="el-icon-loading"  class="m-c ccl" ref="cardlist" :list="data" @handle-page-num="handlePageNum" @handle-page="handlePage">
        <div class="searchBar">
          <span class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 个园区</span>
        </div>
      </company-card-list>
    <slot></slot>
  </div>
</template>

<script>
import mapHeadCheckBox from '@/views/parkCustomer/components/mapHeadCheckBox'
import companyCardList from '@/views/parkCustomer/components/companyCardList'
import { mapState} from 'vuex'
import { X_BLOCK } from '@/utils/iframeUtils'
import { proximity } from '../api/index'

export default {
  name: 'drawerEnterpriseList2',
  components: { mapHeadCheckBox, companyCardList },
  props: {
    location: {
      type: Object,
      default: () => ({ site: null, latitude: null, longtitude: null, distance: 0 })
    }
  },
  watch: {
  },
  data () {
    return {
      pageNum: 1,
      loading: true,
      condition: {},
      total: 0,
      data: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      qwMap: false, // 是否是嵌套
      isUnlock: false
    }
  },
  computed: {
    _totalElements () {
      if (this.total < 100) return this.total
      if (this.total < 200000) return `${this.total.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    }
  },
  created () {
  },
  mounted () {
    if (window[X_BLOCK]) {
      console.log('X_BLOCK')
      this.qwMap = true
    }
    this.initData()
  },
  methods: {
    initData () {
      this.condition = {}
      this.currentChange(1)
    },
    handlePage (val) {
      if (this.data.pageNum !== val) {
        this.currentChange(val)
      }
    },
    handlePageNum (val) {
      this.data.pageNum = 1
      this.data.pageSize = val
      this.loadData(this.condition)
    },
    currentChange (num) {
      this.data.pageNum = num
      this.loadData(this.condition)
    },
    async loadData (val) {
      const { distance, latitude, longtitude, site } = this.location
      if (!site) {
        this.loading = false
        return
      }
      this.loading = true
      const pageNum = this.data.pageNum
      const pageSize = this.data.pageSize
      const isUnLock = this.isUnlock ? 1 : 0
      const params = { distance, latitude, longtitude, pageNum, pageSize, ...val, isUnLock }
      const { data } = await proximity(params)
      const { total, list } = data || { total: 0, list: [] }
      this.total = total
      this.data = { ...this.data, total: Math.min(total, 5000), tableData: list }
      this.loading = false
    }
  },
  destroyed () {
  }
}

</script>
<style lang='scss' scoped>
.font-15-md{
  font-size: 15px;
  font-weight: 600;
  color: rgba(52,57,81,0.7);
}
.m-c {
  width: 1011px;
  margin: 0 auto;
}
.drawer-container {
  width:1055px;
  height: 100vh;
  padding: 12px 0;
  background-color: #F5F6F8;
  &.qwMap{
    width: 920px;
    .m-c{
      width: 96%;
    }
  }
}
.ccl {
  height: calc(100vh - 70px);
  margin-bottom: 0;
  margin-top: 6px !important;
  /deep/ .clueList {
    height: calc(100% - 80px);
    overflow-y: auto;
  }
}
::v-deep{
    .el-loading-spinner{
      .el-loading-text{
          font-weight: 400;
          color: #999999;
          font-size: 13px;
          margin-top: 14px;
    }
    .el-icon-loading:before{
      content: url("~@/assets/gbIcon/loading_icon.png");
    }
  }

  .el-scrollbar__wrap{
    margin-right: 0 !important;
  }

}
</style>
